import type { PickListDesignTokens } from '@primeuix/themes/aura/picklist';

export default {
  root: {
    gap: '1.125rem',
  },
  controls: {
    gap: '0.5rem',
  },
} satisfies PickListDesignTokens;
